export default {
  report_id_label: "ID del informe",
  report_id_placeholder: "Ingrese el ID del informe para buscar",
  type_label: "Tipo",
  type_placeholder: "Seleccione el tipo",
  shared_label: "Compartido",
  shared_placeholder: "Seleccione el estado de compartir",
  report_id: "ID del informe",
  date: "Fecha",
  report_type: "Tipo de informe",
  created_at: "Creado el",
  shared: "Compartido",
  actions: "Acciones",
  view_count: "Número de vistas",
  regenerate: "Regenerar",
  delete_confirm: "¿Está seguro de que desea eliminar este informe?",
  copied: "Enlace copiado al portapapeles",
  copied_with_expire: "Enlace copiado al portapapeles, expirará el {date}",
  copy_failed: "Error al copiar el enlace",
  share_failed: "Error al compartir",
  report_detail: "Detalle del informe",
  preview_title: "Vista previa del informe",
  data_format_error: "Error de formato de datos",
  plan_changed_notice:
    "Su plan ha sido cambiado, ahora se usa el último plan ({planType}) para mostrar este informe.",
  config_changed_notice:
    "Su configuración ha sido cambiada, ahora se usa la última configuración para mostrar este informe.",
  calculation_deleted_notice: "Algunos cálculos han sido eliminados.",
  delete_success: "Eliminado con éxito",
  not_found_title: "Informe no encontrado",
  not_found_desc: "El informe que está buscando no existe",
  share: "Compartir",
  copy_link: "Copiar enlace",
  share_to_x: "Compartir en X",
  share_to_linkedin: "Compartir en LinkedIn",
  unshare: "Dejar de compartir",
  unshare_success: "Informe dejado de compartir con éxito",
  unshare_failed: "Error al dejar de compartir el informe",
  shared_expires_at: "El compartir expira el",
  privacy_fields_hidden:
    "Los campos de privacidad están ocultos por defecto, se pueden modificar en Configuración - Configuración de informe, los cambios surten efecto inmediatamente",
  want_to_calculate:
    "¿Quiere calcular su propio informe de impuesto de carbono CBAM? Obtenga 50 cálculos después del primer cálculo",
  register_free: "Registro gratuito",
  use_invitation_code: "Usar código de invitación",
  failed_to_load_shared_report: "Error al cargar el informe compartido",
  report_data_missing: "Faltan datos del informe",
  unable_to_get_shared_report: "No se pueden obtener los datos del informe compartido",
  carbon_emission_report: "Informe de emisiones de carbono",
  check_out_carbon_emission: "Consulte este informe de emisiones de carbono",
};
